/* eslint-disable react/display-name */
import DefaultCountdown from './v146'

export default function Countdown(props: CountdownProps) {
  const { version } = props
  switch (version) {
    case 'v146':
    default:
      return <DefaultCountdown {...props} />
  }
}

export type CountdownProps = {
  version?: string
  time?: number
  template?: number
  className?: string
  callBack?: () => void
  isPause?: boolean
}
